import { render, staticRenderFns } from "./CreateNewRoleAccessModal.vue?vue&type=template&id=14d1235f"
import script from "./CreateNewRoleAccessModal.vue?vue&type=script&lang=js"
export * from "./CreateNewRoleAccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports